import React from "react";
import ioClient from "socket.io-client";
import { DEBUG } from "../../utils/secrets";

function useSocketIo(
  url: string,
  ioOptions?: SocketIOClient.ConnectOpts
): [SocketIOClient.Socket, boolean] {
  const io = React.useMemo(() => ioClient(url, ioOptions), [url, ioOptions]);
  const [connected, setConnected] = React.useState<boolean>(false);

  React.useEffect(() => {
    io.off("connect");
    io.on("connect", () => {
      if (DEBUG) {
        console.info("Socket is connected to", url);
      }
      setConnected(() => true);
    });

    io.off("disconnect");
    io.on("disconnect", () => {
      if (DEBUG) {
        console.info("Socket was disconnected from ", url);
      }
      setConnected(() => false);
    });

    return () => {
      io.removeAllListeners();
      io.close();
    };
  }, [url, io]);

  return [io, connected];
}

export default useSocketIo;
